import {getHideDeclinedOrders} from './orderVisibilityPreferences';

export const ORDER_SORT_OPTIONS=[
  {value:'newest',label:'Newest first'},
  {value:'oldest',label:'Oldest first'},
  {value:'amount-high',label:'Amount: high to low'},
  {value:'amount-low',label:'Amount: low to high'},
  {value:'status',label:'Status'}
];

const numericAmount=(order)=> Number(order?.total_amount || order?.total_price || 0);

const searchText=(order)=> [
  order?.id,
  order?.seller?.business_name,
  order?.buyer?.name,
  order?.buyer?.email,
  order?.status,
  order?.delivery_method,
  ...(order?.items || []).flatMap(item=> [
    item?.title,
    item?.description
  ])
].filter(Boolean).join(' ').toLowerCase();

export const isDashboardVisibleOrder=(order)=>{
  return !(
    order?.payment_mode==='platform'
    && order?.status==='pending'
    && order?.payment_authorized!==true
  );
};

export const filterAndSortOrders=(orders=[],options={})=> {
  const {
    search='',
    status='all',
    sort='newest',
    role='buying',
    userId,
    sellerId,
    hideCancelled=false,
    hideDeclined=false
  }=options;

  const normalizedSearch=search.trim().toLowerCase();
  const storedHideDeclined=getHideDeclinedOrders(userId);
  const shouldHideDeclined=hideDeclined || storedHideDeclined;

  const visibleOrders=orders.filter(order=> {
    if (!isDashboardVisibleOrder(order)) return false;

    const isBuyingOrder=order?.buyer_id===userId;
    const isSellingOrder=Boolean(
      sellerId &&
      order?.seller_id===sellerId
    );

    const matchesRole=role==='selling'
      ? isSellingOrder
      : isBuyingOrder;

    const matchesStatus=status==='all' || order?.status===status;
    const matchesCancelledVisibility=
      !hideCancelled || order?.status!=='cancelled';
    const matchesDeclinedVisibility=
      !shouldHideDeclined || order?.status!=='declined';
    const matchesSearch=!normalizedSearch ||
      searchText(order).includes(normalizedSearch);

    return matchesRole
      && matchesCancelledVisibility
      && matchesDeclinedVisibility
      && matchesStatus
      && matchesSearch;
  });

  return [...visibleOrders].sort((first,second)=> {
    if (sort==='oldest') {
      return new Date(first.created_at)-new Date(second.created_at);
    }

    if (sort==='amount-high') {
      return numericAmount(second)-numericAmount(first);
    }

    if (sort==='amount-low') {
      return numericAmount(first)-numericAmount(second);
    }

    if (sort==='status') {
      return String(first.status || '').localeCompare(
        String(second.status || '')
      );
    }

    return new Date(second.created_at)-new Date(first.created_at);
  });
};
